import Image from "next/image";
import { FC, useEffect } from "react";
import { getCurrentLocale } from "../i18n";
import { IBlog } from "../utils/types";

interface IPopupBlogProps {
  blog: IBlog | null;
  onClose: () => void;
}

const PopupBlog: FC<IPopupBlogProps> = ({ blog, onClose }) => {
  const currentLocale = getCurrentLocale();

  const handleBackgroundClick = (e: any) => {
    if (e.target.className === "popup") {
      onClose();
    }
  };

  useEffect(() => {
    document.ontouchmove = (event) => {
      // @ts-ignore
      if (event.target.className === "popup-content") {
        if (event.touches.length === 1) {
          event.preventDefault();
        }
      }
    };
    document.body.style.overflow = "hidden"
    return () => {
      document.ontouchmove = (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
      };
      document.body.style.overflow = "initial"
    };
  }, []);

  return (
    <div className="popup-wrapper" onClick={handleBackgroundClick}>
      <input type="checkbox" className="popup-checkbox" id="popupCheckboxOne" />
      {/* <div className="popup without-background-popup"> */}
      <div className="popup">
        <div className="popup-content">
          <label
            htmlFor="popupCheckboxOne"
            className="popup-closer"
            onClick={onClose}
          >
            &#215;
          </label>
          <div className="popup-view scrollable">
            <div className="popup-view-img">
              {blog && (
                // <Image className="popup-view-blog-img" width={'100%'} height={'100%'} src={blog.image} alt={currentLocale === 'en' ? blog.name_en : blog.name} />
                <img
                  className="popup-view-blog-img"
                  src={blog.image}
                  alt={currentLocale === "en" ? blog.name_en : blog.name}
                />
              )}
            </div>
            {blog && (
              <>
                <h4 className="popup-view-blog-title">
                  {currentLocale === "en" ? blog.name_en : blog.name}
                </h4>
                <p className="popup-view-blog-text">
                  {currentLocale === "en" ? blog.text_en : blog.text}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupBlog;
